<div class="h-full flex flex-col patternBG">
  <div class="scrolled flex-1 p-4">
    <!-- Main comp  -->
    <div class="w-full flex flex-col gap-5 items-center">
      <div class="w-full sm:max-w-[1000px] mx-auto">
        <!-- Welcome message  -->
        <div class="flex flex-col items-center justify-center gap-5 xs:gap-2.5 text-center layout-padd">
          <div>
            <span class="main-title-font" style="font-size: 40px;"
              [ngStyle.xs]="{'font-size': '30px'}">{{"pof.welcome"|translate}}</span>
          </div>
          <div>
            <span class="main-title-font" style="font-size: 30px;"
              [ngStyle.xs]="{'font-size': '20px'}">{{(!pointVisible() ? "noPof" : "pof.select")|translate}}</span>
          </div>
        </div>

        <!-- Points of sale list  -->
        <div *ngIf="pointsOfSale" class="grid grid-cols-1 md:grid-cols-2 gap-6 justify-items-center my-6">

          <!-- Pos card  -->
          <div *ngFor="let point of pointsOfSale;" class="w-full">

            <div (click)="selectPOS(point);" *ngIf="pointVisible()"
              class="w-full bg-white rounded-lg shadow-md overflow-hidden relative hover:shadow-lg transition cursor-pointer">

              <!-- Banner -->
              <div class="relative h-32 sm:h-40 bg-gray-300">
                <img src="{{(point.banner? (point.banner | prodSizeFilter:'1920') : banner_by_default)}}"
                  alt="Banner" class="w-full h-full object-cover">

                <!-- Bouton horaires -->
                <div class="absolute top-2 right-2">
                  <app-fulle-thumbnail-shedules [point_of_sale]="point" [isBlock]="true" class="shedules-abs">
                  </app-fulle-thumbnail-shedules>
                </div>

              </div>

              <!-- Content -->
              <div class="flex items-center gap-4 p-4">

                <!-- Logo -->
                <img src="{{(point.img? (point.img | prodSizeFilter:'72') : logo_by_default)}}" alt="Logo"
                  class="w-16 h-16 rounded-full object-cover border">

                <!-- Infos -->
                <div>
                  <h3 class="text-base font-semibold text-gray-800 mb-2">{{point.denomination}}</h3>
                  <div class="text-sm text-gray-500">{{point.address | uppercase}}</div>
                  <div class="text-sm text-gray-500">{{point.postal | uppercase}} {{point.city | uppercase}}</div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div>

  <!-- Footer  -->
  <app-powered-fulle class="divider-top"></app-powered-fulle>

</div>